import * as React from "react";

function SvgFirebase(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 255.4 351"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path
        d="M0 283l2.1-3L102.5 89.5l.2-2L58.5 4.4C54.8-2.6 44.4-.8 43.1 7L0 283z"
        fill="#ffc24a"
      />
      <path
        d="M1.3 280.7l1.6-3.1 99.4-188.5L58.1 5.6c-3.7-6.9-13-5.1-14.2 2.6L1.3 280.7z"
        fill="#ffa712"
      />
      <path d="M1.3 280.7l1.6-3.1 99.4-188.5L58.1 5.6c-3.7-6.9-13-5.1-14.2 2.6L1.3 280.7z" />
      <path
        d="M135 150.4l33-33.8-33-62.9c-3.1-6-11.9-6-15 0l-17.6 33.6v2.9l32.6 60.2z"
        fill="#f4bd62"
      />
      <path
        d="M134.4 149l32-32.8-32-61c-3-5.8-10.4-6.4-13.4-.6l-17.7 34.1-.5 1.7 31.6 58.6z"
        fill="#ffa50e"
      />
      <path d="M134.4 149l32-32.8-32-61c-3-5.8-10.4-6.4-13.4-.6l-17.7 34.1-.5 1.7 31.6 58.6z" />
      <path
        fill="#f6820c"
        d="M0 283l1-1 3.5-1.4 128.4-128 1.7-4.4-32.1-61.1z"
      />
      <path
        d="M139.1 347.6l116.3-64.8-33.2-204.6c-1-6.4-8.9-8.9-13.5-4.3L0 283l115.6 64.5c7.3 4.1 16.2 4.1 23.5.1"
        fill="#fde068"
      />
      <path
        d="M254.4 282.2l-33-202.9c-1-6.3-7.6-9-12.1-4.4L1.3 282.6l114.3 63.9c7.2 4 16.1 4 23.3 0l115.5-64.3z"
        fill="#fcca3f"
      />
      <path
        d="M139.1 345.6c-7.3 4.1-16.2 4.1-23.5 0L.9 282l-.9 1 115.6 64.5c7.3 4.1 16.2 4.1 23.5 0l116.3-64.8-.3-1.8-116 64.7z"
        fill="#eeab37"
      />
    </svg>
  );
}

export default React.forwardRef(SvgFirebase);
